export enum OsType {
  Android = 'android',
  Ios = 'ios',
}
